import { CopyIcon, EyeSlashIcon, LockKeyIcon, PushPinIcon, TrashSimpleIcon } from "@phosphor-icons/react";

import { ICON_SIZE } from "@/config/constants";
import { FetchedNote, AddNote } from "@/services/api/fetchers/notes";
import { NestedContentNavigator, NestedAction } from "@/shared/components/ui/NestedContentNavigator";

interface MoreNoteCardActionsProps {
  note: FetchedNote;
  userId: string | null;
  onAddNote: (note: AddNote) => void;
  onClose: () => void;
  onTempDeleteNote: (id: number) => void;
  onUpdateNote: (id: number, updates: Partial<FetchedNote>, shared: boolean) => void;
}

export function NoteCardMoreActions({
  note,
  userId,
  onAddNote,
  onClose,
  onTempDeleteNote,
  onUpdateNote,
}: MoreNoteCardActionsProps) {
  const actions: NestedAction[] = [
    {
      key: "pin",
      label: note.pinned ? "Unpin" : "Pin",
      icon: <PushPinIcon size={ICON_SIZE.sm} weight={note.pinned ? "fill" : "regular"} />,
      run: () => {
        onUpdateNote(note.id, { pinned: !note.pinned }, Boolean(note.public_uuid));
        onClose();
      },
    },
    {
      key: "lock",
      label: note.locked ? "Unlock" : "Lock",
      icon: <LockKeyIcon size={ICON_SIZE.sm} weight={note.locked ? "fill" : "regular"} />,
      run: () => {
        onUpdateNote(note.id, { locked: !note.locked }, Boolean(note.public_uuid));
        onClose();
      },
    },
    {
      key: "mask",
      label: note.masked ? "Unmask" : "Mask",
      icon: note.masked ? <EyeSlashIcon size={ICON_SIZE.sm} weight="fill" /> : <EyeSlashIcon size={ICON_SIZE.sm} />,
      run: () => {
        onUpdateNote(note.id, { masked: !note.masked }, Boolean(note.public_uuid));
        onClose();
      },
    },
    {
      key: "duplicate",
      label: "Duplicate",
      icon: <CopyIcon size={ICON_SIZE.sm} />,
      run: () => {
        if (!userId) {
          return;
        }
        onAddNote({
          html_content: note.html_content,
          text_content: note.text_content,
          user_id: userId,
          folder_id: note.folder_id,
        });
        onClose();
      },
    },
    {
      key: "delete",
      label: "Delete",
      icon: <TrashSimpleIcon size={ICON_SIZE.sm} />,
      run: () => {
        onTempDeleteNote(note.id);
        onClose();
      },
    },
  ];

  return <NestedContentNavigator actions={actions} />;
}
